import React from "react";
import { BackgroundImage, HeaderComponent } from "../../FifthComponents";

const WhoWeAre = (props) => {
    const { selectedLanguage } = props;
    return (
        <div>
            <BackgroundImage screenName={selectedLanguage?.txt_who_we_are} classForBg='fifth-des-who-we-are-bg' {...props} />
            <HeaderComponent title={selectedLanguage?.txt_who_we_are} lineClass='bg-gray' titleClass='color-blue' />
            <div className="who-we-are-main-div">
                <h2>
                    {selectedLanguage?.txt_healthcare_gate_to_wellbeing}
                </h2>
                <p>
                    {selectedLanguage?.txt_amsterdam_clinics_description}
                </p>
            </div>
        </div>
    )
}
export default WhoWeAre